import { render, staticRenderFns } from "./InstuifTrainingsschema.vue?vue&type=template&id=a065285c&scoped=true&"
var script = {}
import style0 from "./InstuifTrainingsschema.vue?vue&type=style&index=0&id=a065285c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a065285c",
  null
  
)

export default component.exports